// import { loadStripe } from '@stripe/stripe-js';
// import { removeVettingFrom } from '../redux/user/userReducer';
import publicApiCall from "../utils/axiosCall";
import { errorToast } from "../utils/toast";

const getCategory = async (category) => {
  return await publicApiCall.get(`app/categories?kind=${category}`).catch((err) => {
    errorToast(err?.response.data?.message);
  });
};

const getSuperCategory = async (category) => {
  return await publicApiCall.get(`app/super-campaign-names`).catch((err) => {
    errorToast(err?.response.data?.message);
  });
};

const getImpactCategory = async (category) => {
  return await publicApiCall.get(`app/active-projects?category=${category}`).catch(
    (err) => {
      errorToast(err?.response.data?.message);
      return {
        data: { impactInitiatives: [] },
      };
    }
  );
};

const createCampaign = (campaign, navigate) => (dispatch) => {
  publicApiCall.post(`campaign/register`, campaign, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      successToast(res.data?.message);
      dispatch(removeVettingFrom());
      navigate('/dashboard/my-campaign');
    })
    .catch((err) => {
      errorToast(err.response.data?.message);
    });
};

const updateCampaign = (campaign, id, navigate) => (dispatch) => {
  publicApiCall.put(`campaign/update-campaign-request/${id}`, campaign)
    .then((res) => {
      successToast(res.data?.message);
      navigate('/dashboard/my-campaign');
    })
    .catch((err) => {
      errorToast(err.response.data?.message);
    });
};

const updateApproveCampaign = (campaign, id, navigate) => (dispatch) => {
  publicApiCall.put(`campaign/campaign-update-request/${id}`, campaign)
    .then((res) => {
      successToast(res.data?.message);
      navigate('/dashboard/my-campaign');
    })
    .catch((err) => {
      errorToast(err.response.data?.message);
    });
};

const createNFT = (campaign, purpose, setData, navigate) => (dispatch) => {
  let link =
    purpose === '0'
      ? 'creator/create-to-contribute-bulk'
      : purpose === '1'
        ? 'creator/create-to-gift'
        : purpose === '2'
          ? 'creator/create-reward-nft'
          :'user/marketplace/list-on-marketplace'

  publicApiCall.post(`${link}`, campaign, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((res) => {
      successToast(res.data?.message);

      if (purpose === '1'||purpose === '2') {
        const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);
        stripePromise.then((stripe) => {
          stripe.redirectToCheckout({
            sessionId: res.data.sessionId,
          });
        });
      }

      setData({
        purpose: '0',
        nft: {
          value: null,
          error: '',
        },
        itemName: {
          value: '',
          error: '',
        },
        description: {
          value: '',
          error: '',
        },
        priceUsd: {
          value: '',
          error: '',
        },
        nftCategory: {
          value: '',
          error: '',
        },
        impactCategory: {
          value: '',
          error: '',
        },
        impactCampaign: {
          value: '',
          error: '',
        },
        percentageToImpact: {
          value: '',
          error: '',
        },
        giftRecipientAddress: {
          value: '',
          error: '',
        },
      });
      navigate('/dashboard/nft-collections');
    })
    .catch((err) => {
      errorToast(err?.response?.data?.message);
    });
};
const contributeNFT = (campaign, purpose, setData, navigate) => (dispatch) => {
  let link = 'user/marketplace/list-on-marketplace';

  publicApiCall.post(`${link}`, campaign)
    .then((res) => {
      successToast(res.data?.message);

      if (purpose === '1') {
        const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);
        stripePromise.then((stripe) => {
          stripe.redirectToCheckout({
            sessionId: res.data.sessionId,
          });
        });
      }

      setData({
        purpose: '0',
        nft: {
          value: null,
          error: '',
        },
        itemName: {
          value: '',
          error: '',
        },
        description: {
          value: '',
          error: '',
        },
        priceUsd: {
          value: '',
          error: '',
        },
        nftCategory: {
          value: '',
          error: '',
        },
        impactCategory: {
          value: '',
          error: '',
        },
        impactCampaign: {
          value: '',
          error: '',
        },
        percentageToImpact: {
          value: '',
          error: '',
        },
        giftRecipientAddress: {
          value: '',
          error: '',
        },
      });
      navigate('/dashboard/user-collections');
    })
    .catch((err) => {
      errorToast(err?.response?.data?.message);
    });
};

const getAllPendingCampaigns = async () => {
  return await publicApiCall.get(`campaign/campaign-requests?status=PENDING`).catch(
    (err) => {
      errorToast(err.response.data?.message);
    }
  );
};

const getUserCollection = async (offset) => {
  return await publicApiCall.get(`creator/my-collections-names?limit=3&offset=${offset}`).catch(
    (err) => {
      errorToast(err.response.data?.message);
    }
  );
};
const getCollections = async (offset) => {
  return await  publicApiCall.get(`creator/my-collections?limit=100&offset=${offset}`).catch(
    (err) => {
      errorToast(err.response.data?.message);
    }
  );
};
const getPublicCollections = async (offset) => {
  return await  publicpublicApiCall.get(`app/public-collections?limit=10&offset=${offset}`).catch(
    (err) => {
      errorToast(err.response.data?.message);
    }
  );
};
const getAllApproveCampaigns = async () => {
  return await publicApiCall.get(`campaign/`).catch((err) => {
    errorToast(err.response.data?.message);
  });
};

const getAllRoleRequest = async () => {
  return await publicApiCall.get(`/user/role-request`).catch((err) => {
    errorToast(err.response.data?.message);
  });
};

export {
  getCategory,
  createCampaign,
  contributeNFT,
  getImpactCategory,
  createNFT,
  updateApproveCampaign,
  getAllPendingCampaigns,
  getAllApproveCampaigns,
  getAllRoleRequest,
  getSuperCategory,
  updateCampaign,
  getUserCollection,
  getCollections,
  getPublicCollections,
};
